module.exports = __webpack_public_path__ + "img/category-skill-game.6933c685.png";